import React, { useState } from "react";
import { MenuOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./Sidebar.css";
import { useSelector, useDispatch } from "react-redux";
import { updateAuth } from "../../Redux/AuthSlice";
import logo from "../../Assets/Images/logo.png";
import IconA from "../../Assets/sidebar/icon1.png";
import cardImage from "../../Assets/sidebar/gameimage.png";

// import IconB from "../../Assets/sidebar/icon2.png";
// import Icon3 from "../../Assets/sidebar/icon3.png";

export default function SidebarBOT() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const { userId } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();

  const LogoutHandler = (e) => {
    dispatch(
      updateAuth({ aexnglobalAuth: false, userId: null, jwtToken: null })
    );
    localStorage.clear();
  };

  return (
    <>
      <div className="sidebar position-relative " id="sidebar">
        <Link to="/DashboardBOT" className="leftisidelogo">
          <img className="h-100 w-100" src={logo} alt="" />
        </Link>

        <div className="dropdown dropdowSidebar sideanker">
          <Link
            className="btn btnsecondary dropdown-toggle w-100 text-start"
            to="/DashboardBOT"
          >
            Dashboard
          </Link>
        </div>
        <div className="dropdown dropdowSidebar">
          <Link
            className="btn btnsecondary dropdown-toggle w-100 text-start"
            to=""
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Deposit
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link className="dropdown-item" to="/Deposit">
                Deposit
              </Link>
            </li>
            <li>
              {
                <Link className="dropdown-item" to="/DepositHistory">
                  Deposit History
                </Link>
              }
            </li>
          </ul>
        </div>
        <div className="dropdown dropdowSidebar">
          <Link
            className="btn btnsecondary dropdown-toggle w-100 text-start"
            to=""
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Activation / Upgrade
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link className="dropdown-item" to="/ActivateBOT">
                Activation (Magic)
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/Activate_HistoryBOT">
                Activation History (Magic)
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/ActivateFOREX">
                Activation (FOREX)
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/Activate_HistoryFOREX">
                Activation History (FOREX)
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/DownlineActHistoryBOT">
                Downline Activation History (Magic/FOREX)
              </Link>
            </li>
          </ul>
        </div>
        <div className="dropdown dropdowSidebar">
          <Link
            className="btn btnsecondary dropdown-toggle w-100 text-start"
            to=""
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Team Details
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link className="dropdown-item" to="/DirectTeamBOT">
                Direct Team
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/LevelDetailsBOT">
                Level Details
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/DownLineTeamBOT">
                Downline Team
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/MatchingTreeBot">
                Binary Tree
              </Link>
            </li>
            {/* <li><Link className="dropdown-item" to="/Direct_Leg_Business">Direct Leg Business</Link></li> */}
          </ul>
        </div>

        <div className="dropdown dropdowSidebar">
          <Link
            className="btn btnsecondary dropdown-toggle w-100 text-start"
            to=""
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            MAGIC PLAN Income
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link className="dropdown-item" to="/DirectIncomeBot">
                Direct Income
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/ROIIncomeBot">
                Trading Income
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/ROIlevelIncomeBot">
                Trading Level Income
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/MatchingIncomeBot">
                Matching Income
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/MatchingLevelIncomeBot">
                Matching Level Income
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/RewardInomeBot">
                Lifetime Reward
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/ClubIncomeBot">
                Club Income
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/ClubRoyaltyIncomeBot">
                Club Royalty Income
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/FranchiseInomeBot">
                Franchisee Income
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/CashbackIncomeBot">
                CashBack Income
              </Link>
            </li>
          </ul>
        </div>

        <div className="dropdown dropdowSidebar">
          <Link
            className="btn btnsecondary dropdown-toggle w-100 text-start"
            to=""
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Magic Income Wtihdawal
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link className="dropdown-item" to="/WithdrawalBOT">
                Withdrawal
              </Link>
            </li>
            <li>
              {/* <Link className="dropdown-item" to="/WithdrawalHistoryBOT"> */}
              <Link className="dropdown-item" to="/WithdrawalHistoryBOT">
                Withdrawal History
              </Link>
            </li>
          </ul>
        </div>

        {/* <div className="dropdown dropdowSidebar sideanker d-sm-none d-block">
          <Link
            className="btn btnsecondary dropdown-toggle w-100 text-start"
            to="/Notification"
          >
            Notification
          </Link>
        </div> */}
        <div className="dropdown dropdowSidebar">
          <Link
            className="btn btnsecondary dropdown-toggle w-100 text-start"
            to=""
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            HelpDesk
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link className="dropdown-item" to="/HelpDeskBoat">
                Raise A Query
              </Link>
            </li>
          </ul>
        </div>
        <div className="dropdown dropdowSidebar sideanker">
          <Link
            className="btn btnsecondary dropdown-toggle w-100 text-start"
            to="/"
            onClick={LogoutHandler}
          >
            Logout
          </Link>
        </div>
      </div>
    </>
  );
}
